module.exports = __webpack_public_path__ + "img/02.6a9e2974.svg";